import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { patchProjectVisibility } from '~/lib/.client/api/projects';
import type { ProjectVisibility } from '~/lib/projects';
import { projectStore } from '~/lib/stores/project';
import { invariant } from '~/utils/invariant';
import { logger } from '~/utils/logger';

export function useProjectVisibility() {
  const onProjectVisibilityChange = useCallback(async (visibility: ProjectVisibility) => {
    const prevVisibility = projectStore.visibility.get();

    try {
      const slug = projectStore.getSlug();

      invariant(slug);

      projectStore.visibility.set(visibility);

      await patchProjectVisibility(slug, visibility);

      toast.success(`Project visibility updated to ${visibility}`);
    } catch (error) {
      logger.error(error);

      if (prevVisibility) {
        projectStore.visibility.set(prevVisibility);
      }

      toast.error('Failed to update the project visibility. Please try it again.');

      throw new Error('Failed to update project visibility');
    }
  }, []);

  return {
    onProjectVisibilityChange,
  };
}
